import React from "react";
import { Radio, Space, Divider } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import PageRoutes from "../../../utils/routes";

const AdvertMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      label: "Favori İlanlarım",
      value: PageRoutes.favoriteAdverts,
      path: PageRoutes.favoriteAdverts,
    },
    {
      label: "Başvurduğum İlanlar",
      value: PageRoutes.appliedAdverts,
      path: PageRoutes.appliedAdverts,
    },
    {
      label: "Bana Göre İlanlar",
      value: PageRoutes.recommendedAdverts,
      path: PageRoutes.recommendedAdverts,
    },
    {
      label: "Kabul Edildiğim İlanlar",
      value: PageRoutes.assignedAdverts,
      path: PageRoutes.assignedAdverts,
    },
  ];

  const getCurrentValue = () => {
    const currentPath = location.pathname;
    return (
      menuItems.find((item) => currentPath === item.path)?.value ||
      PageRoutes.favoriteAdverts
    );
  };

  const handleChange = (e) => {
    const selectedItem = menuItems.find(
      (item) => item.value === e.target.value
    );
    if (selectedItem) {
      navigate(selectedItem.path);
    }
  };

  return (
    <div>
      <Radio.Group
        style={{
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: "0",
          padding: "16px",
          backgroundColor: "white",
          width: "100%",
          marginTop: 36,
        }}
        onChange={handleChange}
        value={getCurrentValue()}
        optionType="button">
        <Space direction="vertical" style={{ width: "100%" }}>
          {menuItems.map((item, index) => (
            <React.Fragment key={item.value}>
              <Radio
                value={item.value}
                style={{
                  width: "100%",
                  textAlign: "left",
                  border: "none",
                  padding: "8px 0",
                }}>
                {item.label}
              </Radio>
              {index < menuItems.length - 1 && (
                <Divider orientation="right" style={{ margin: "8px 0" }} />
              )}
            </React.Fragment>
          ))}
        </Space>
      </Radio.Group>
    </div>
  );
};

export default AdvertMenu;
